export const getFileType = (file) => {
    const fileType = file?.fileType?.split('/')[0];

    switch (fileType) {
        case 'image':
            return 'image';
        case 'video':
            return 'video';
        case 'audio':
            return 'audio';
        case 'application':
            return 'file';
        default:
            return 'file';
    }
};

const escapeCsvValue = (value) => {
    if (value === null || value === undefined) return '';
    const stringValue = String(value).replace(/\r?\n|\r/g, ' ');
    if (/[",]/.test(stringValue)) {
        return `"${stringValue.replace(/"/g, '""')}"`;
    }
    return stringValue;
};

export const downloadCsv = ({ fileName, headers, rows }) => {
    const csvHeaders = headers.map((header) => escapeCsvValue(header.label)).join(',');
    const csvRows = rows.map((row) => headers.map((header) => escapeCsvValue(row[header.key])).join(','));
    const csvContent = [csvHeaders, ...csvRows].join('\n');
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');

    link.href = url;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
};
